import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import RosettaFormattedMessage, { decorateIntlMessages } from '../../../common/rosetta_formatted_message';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../../../utils/analytics';
import { scrollToTopDesktopAd } from '../../../../utils/slideshow';
import { defineMessages, injectIntl } from 'react-intl';

const i18nMessages = decorateIntlMessages(__filename, defineMessages({
  begin_cta: {
    id: 'begin_cta',
    description: 'Call-to-action to begin slideshow',
    defaultMessage: 'Begin Slideshow'
  }
}));

export class SlideInfo extends Component {
  handleClick = () => {
    sendAnalyticsEvent(
      'Slideshow',
      'Click',
      'Begin Top Button'
    );
    sendDataLayerEvent('Click', {
      actionType: 'Begin Slideshow',
      itemName: 'Slideshow',
      pageModule: 'Slideshow',
      slideshowComponent: 'Below Text'
    });
    this.props.handleChangeSlide();
    scrollToTopDesktopAd();
  };

  render() {
    const { nextSlideLocation, slideCount, slideIndex, intl } = this.props;

    if (slideIndex === 0) {
      return (
        <Link to={nextSlideLocation}
          title={intl.formatMessage(i18nMessages.begin_cta)}
          className="slide-info intro-slide"
          onClick={this.handleClick}
        >
          <div className="slide-info-text">
            <RosettaFormattedMessage parentFilename={__filename}
              id="begin_cta"
              description="Call-to-action to begin slideshow"
              defaultMessage="Begin Slideshow"
            />
          </div>
        </Link>
      );
    }
    return (
      <div className="slide-info">
        <div className="slide-info-text">
          <RosettaFormattedMessage parentFilename={__filename}
            id="index_and_count"
            description="Slide info displaying current slide and total slides"
            defaultMessage="{index} of {count}"
            values={{ index: slideIndex, count: slideCount }}
          />
        </div>
      </div>
    );
  }
}

export default injectIntl(SlideInfo);

SlideInfo.propTypes = {
  handleChangeSlide: PropTypes.func,
  slideIndex: PropTypes.number.isRequired,
  nextSlideLocation: PropTypes.object,
  slideCount: PropTypes.number,
  intl: PropTypes.object.isRequired
};
